<template>
	<div class="report-detail">
		<!-- 日期选择器 -->
		<date-switch-selector
			ref="dateSwitch"
			title="整体效果"
			:hint="true"
			lastMonth
			:timeType="pickerType"
			@reportData="getReportDetail"
			@describeDate="describeDate"
		>
			<div class="hint" slot="hint">
				<div class="title">效果报告</div>
				<div><span>覆盖国家/地区：</span>指网站触达人群所涉及的国家/地区的总和</div>
				<div><span>覆盖人数：</span>指广告展示次数与Facebook帖子覆盖人数的总和</div>
				<div><span>触达潜在采购商：</span>指进入网站用户数和Facebook主页浏览量的总和</div>
				<div>
					<span>销售线索：</span
					>指通过全球赢获得的有效客户信息，表单询盘、邮件询盘与Facebook互动数的总和
				</div>
			</div>
		</date-switch-selector>
		<!-- 信息展示 -->
		<el-row class="message-show">
			<el-col :span="24" class="customer-info">
				<div class="info-item">公司名称：{{ reportDetail.customerName || '-' }}</div>
				<div class="info-item">服务人员：{{ reportDetail.serviceStaffName || '-' }}</div>
				<div class="info-item">
					<span class="iconfont">
						<ig-icon name="yituisong"></ig-icon>
					</span>
					<el-popover
						placement="top-start"
						width="400"
						trigger="hover"
						:disabled="statusDisabled"
						content="CID数据查询失败"
					>
						<span slot="reference">推送状态：{{ flagPushStatus }}</span>
					</el-popover>
				</div>

				<div class="info-item">
					<el-popover
						placement="top-start"
						width="400"
						trigger="hover"
						:disabled="ReadDisabled"
						:content="readList"
					>
						<span slot="reference">是否已读：{{ flagRead }}</span>
					</el-popover>
				</div>
				<div class="info-item">
					<span class="iconfont">
						<ig-icon name="riqi"></ig-icon>
					</span>
					<span>{{ reportDetail.pushTime || '-' }}</span>
				</div>
			</el-col>

			<el-col class="data-show">
				<div class="data-time">{{ dataPandectPeriod }}</div>
				<div class="data-info">
					覆盖全球
					<span class="info">{{ thousands(effectReport.regionCount) }}</span
					>个国家/地区的 <span class="info">{{ thousands(coverAndimpressions) }}</span
					>人；触达了 <span class="info">{{ thousands(visitorAndPageView) }}</span
					>个潜在采购商；收获 <span class="info">{{ thousands(totalAndinteractive) }}</span
					>个销售线索
				</div>
			</el-col>
		</el-row>

		<el-row class="statistics" type="flex" justify="space-between" align="center">
			<el-col class="inquiry-detail mg-right" :span="12">
				<client-module moduletitle="询盘详情" @viewDetails="viewInqquiryList">
					<div style="padding: 24px; margin-bottom: 6px;">
						新增询盘{{ effectReport.total || 0 }}个
					</div>
					<sky-charts
						:chartData="chartData"
						ref="chart"
						:config="chartConfig"
						legendPosition="right"
						:showTitle="false"
						:showShadow="false"
						:extend="extend"
					>
						<div>插入内容</div>
					</sky-charts>
					<div slot="event" @click="viewMore('enquiryList')">查看询盘列表</div>
				</client-module>
			</el-col>
			<el-col class="website-data mg-left" :span="12">
				<client-module moduletitle="网站数据" @viewDetails="viewWebsiteData">
					<googleorsocial :googleorsocial="googlewebsitedata">
						<span slot="title">覆盖{{ effectReport.regionCount || 0 }}个国家/地区</span>
					</googleorsocial>
					<googleorsocial :googleorsocial="googlewebsitedata2" :slotTitle="false"></googleorsocial>
					<div slot="event" @click="viewMore('website_report')">查看网站数据</div>
				</client-module>
			</el-col>
		</el-row>
		<el-row
			class="statistics"
			style="margin-top: 20px;"
			type="flex"
			justify="space-between"
			align="center"
		>
			<el-col class="inquiry-detail mg-right" :span="12">
				<client-module moduletitle="谷歌推广" @viewDetails="viewGoogleReport">
					<googleorsocial :googleorsocial="googleadvertising">
						<span slot="title" style="color: #fff;">占位符</span>
						<div slot="bottom-name">相比前一周</div>
					</googleorsocial>
					<googleorsocial :googleorsocial="googleadvertising2" :slotTitle="false">
						<div slot="bottom-name">相比前一周</div>
					</googleorsocial>
					<!-- 查看更多 -->
					<div slot="event" @click="viewMore('googleReports')">查看谷歌报告</div>
				</client-module>
			</el-col>
			<el-col class="website-data mg-left" :span="12">
				<client-module moduletitle="Facebook成效数据">
					<googleorsocial :googleorsocial="socialmediainfo">
						<span slot="title">发布了{{ effectReport.postSendCount || 0 }}篇帖子</span>
					</googleorsocial>
					<googleorsocial :googleorsocial="socialmediainfo2" :slotTitle="false"></googleorsocial>
				</client-module>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import dateSwitchSelector from '@/components/dateSwitchSelector/dateSwitchSelector';
import clientModule from '@/components/client/clientModule/clientModule';
import filters from '@/mixins/filters.js';
import googleorsocial from '@/components/client/googleorsocial/googleorsocial';
import api from '@/backend/services/account/customer.js';
export default {
	data() {
		return {
			chartData: [],
			googleadvertising: {},
			googleadvertising2: {},
			socialmediainfo: {},
			socialmediainfo2: {},
			googlewebsitedata: {},
			googlewebsitedata2: {},
			chartConfig: {},
			extend: {
				series: {
					center: ['40%', '50%'],
				},
			},
			reportDetail: {},
			effectReport: {},
			dataPandectPeriod: '在这一周里',
			pickerType: '',
		};
	},
	computed: {
		flagPushStatus() {
			let { flagPushStatus } = this.reportDetail;
			if (flagPushStatus === null || flagPushStatus === '') return '-';
			return flagPushStatus ? '已推送' : '未推送';
		},
		flagRead() {
			let { flagRead } = this.reportDetail;
			if (flagRead === null || flagRead === '') return '-';
			return flagRead ? '是' : '否';
		},
		readList() {
			let { readList, flagRead } = this.reportDetail;
			if (readList && readList.length != 0 && flagRead) {
				return `${readList[0].accountName} \xa0\xa0\xa0 ${readList[0].createTime}`;
			}
			return '-';
		},
		statusDisabled() {
			let { flagPushStatus } = this.reportDetail;
			if (flagPushStatus == null) {
				flagPushStatus = true;
			}
			return flagPushStatus;
		},
		ReadDisabled() {
			let { flagRead } = this.reportDetail;
			return !flagRead;
		},
		coverAndimpressions() {
			let { effectReport } = this;
			return (effectReport.coverCount || 0) + (effectReport.impressions || 0);
		},
		visitorAndPageView() {
			let { effectReport } = this;
			return (effectReport.visitorCount || 0) + (effectReport.pageViewCount || 0);
		},
		totalAndinteractive() {
			let { effectReport } = this;
			return (effectReport.total || 0) + (effectReport.interactiveCount || 0);
		},
	},
	mounted() {
		let type = this.$route.query.type;
		if (type == 1) this.pickerType = 'week';
		if (type == 2) this.pickerType = 'month';
		this.$refs.dateSwitch.getWeek();
	},
	methods: {
		// 获取成效报告
		async getReportDetail(param) {
			try {
				let { selecttimetype, startDate, endDate } = param;
				let customerId = this.$route.query.id;
				let res = await api.reportDetail({
					customerId,
					type: selecttimetype,
					startDate,
					endDate,
				});
				this.reportDetail = res.data;
				this.effectReport = res.data.effectReport;
				this.setChartConfig(res.data.effectReport);
				this.setgoogleadvertising(res.data.effectReport);
				this.setsocialmediainfo(res.data.effectReport);
				this.setgooglewebsitedata(res.data.effectReport);
			} catch (error) {
				this.setChartConfig();
				this.setgoogleadvertising();
				this.setsocialmediainfo();
				this.setgooglewebsitedata();
			}
		},
		describeDate(date) {
			if (date.type == 'day') {
				let month = new Date(date.start).getMonth() + 1;
				let day = new Date(date.start).getDate();
				this.dataPandectPeriod = `在${month}月${day}日这一天里`;
			}
			if (date.type == 'week') {
				this.dataPandectPeriod = '在这一周里';
			}
			if (date.type == 'month') {
				let month = new Date(date.start).getMonth() + 1;
				this.dataPandectPeriod = `在${month}月这一个月里`;
			}
		},
		// 查看询盘列表
		viewInqquiryList() {},
		// 查看网站数据
		viewWebsiteData() {},
		// 查看谷歌报告
		viewGoogleReport() {},
		// 千分位处理
		thousands(val) {
			return filters.filters.thousands(val);
		},
		// 配置谷歌推广
		setgoogleadvertising(val = {}) {
			this.googleadvertising = {
				list: [
					{
						id: 1,
						title: '展示次数',
						icon: 'zhanshiliang',
						data: filters.filters.thousands(val.impressions),
						rate: filters.filters.number(Math.abs(val.impressionsRingRatio || 0)) + '%',
						state: val.impressionsRingRatio,
						message: {
							site: 'top-start',
							content:
								'广告的展示频率，广告在搜索结果页或 Google 广告网络中的其他网站上显示时，就计为一次展示',
						},
					},
					{
						id: 2,
						title: '点击率',
						icon: 'dianjilv',
						data: filters.filters.jojint(val.clickRate),
						rate: filters.filters.number(Math.abs(val.clickRingRatio || 0)) + '%',
						state: val.clickRingRatio,
						message: {
							site: 'top-start',
							content: '一个比率，表示在看过您广告的用户中有多少用户最后点击了广告',
						},
					},
				],
				type: 'google',
				bottom: true,
			};
			this.googleadvertising2 = {
				list: [
					{
						id: 3,
						title: '总消耗（元）',
						icon: 'zongxiaohao',
						data: filters.filters.rmb(val.exchangeRateCost),
						rate: filters.filters.number(Math.abs(val.exchangeRateCostRingRatio || 0)) + '%',
						state: val.exchangeRateCostRingRatio,
						message: {
							site: 'top-start',
							content: '是指您在指定时间范围内所支出的总费用',
						},
					},
					{
						id: 4,
						title: '点击均价（元）',
						icon: 'dianjijunjia',
						data: filters.filters.rmb(val.clickOnAverage),
						rate: filters.filters.number(Math.abs(val.clickOnAverageRingRatio || 0)) + '%',
						state: val.clickOnAverageRingRatio,
						message: {
							site: 'top-start',
							content: '一个平均值，表示指定时间范围内，每次点击所支出的费用均值',
						},
					},
				],
				type: 'google',
				bottom: true,
			};
		},
		// 配置Facebook成效数据
		setsocialmediainfo(val = {}) {
			this.socialmediainfo = {
				list: [
					{
						id: 1,
						title: '主页浏览量',
						data: filters.filters.thousands(val.pageViewCount),
						icon: 'liulanliang',
						message: {
							site: 'top-start',
							content: '登录和未登录用户查看主页的次数',
						},
					},
					{
						id: 2,
						title: '帖子覆盖人数',
						data: filters.filters.thousands(val.coverCount),
						icon: 'fugairenshu',
						message: {
							site: 'top-start',
							content: '设备屏幕中出现过你的任何主页帖的用户人数。这是预估值，可能不精确',
						},
					},
				],
				itemStyle: {
					height: '161px',
				},
				type: 'socialmedia',
			};
			this.socialmediainfo2 = {
				list: [
					{
						id: 3,
						title: '新粉丝数',
						data: filters.filters.thousands(val.fansCount),
						icon: 'fensishu',
						message: {
							site: 'top-start',
							content: '主页新粉丝人数，这是预估值，可能不精确',
						},
					},
					{
						id: 4,
						title: '互动数',
						data: filters.filters.thousands(val.interactiveCount),
						icon: 'hudongshu',
						message: {
							site: 'top-start',
							content: '用户通过点赞、评论和分享等方式与帖子互动的次数',
						},
					},
				],
				itemStyle: {
					height: '161px',
				},
				type: 'socialmedia',
			};
		},
		// 配置网站数据
		setgooglewebsitedata(val = {}) {
			this.googlewebsitedata = {
				list: [
					{
						id: 1,
						title: '用户数',
						data: filters.filters.thousands(val.visitorCount),
						class: 'one',
					},
					{
						id: 2,
						title: '浏览量',
						data: filters.filters.thousands(val.pvCount),
						class: 'two',
					},
				],
				type: 'websiteData',
			};
			this.googlewebsitedata2 = {
				list: [
					{
						id: 3,
						title: '跳出率',
						data: filters.filters.jojint(val.bounceRatio),
						class: 'three',
					},
					{
						id: 4,
						title: '平均会话时长',
						data: val.avgVisitTimeStr,
						class: 'four',
					},
				],
				type: 'websiteData',
			};
		},
		// 配置询盘图表
		setChartConfig(val = {}) {
			this.chartConfig = {
				type: 'vePie',
				columns: ['platform', 'num'],
				chartSettings: {
					radius: 100,
					labelLine: {
						normal: {
							length: 40,
							length2: 50,
						},
					},
					labelMap: {
						platform: '平台',
						num: '数量',
					},
				},
			};

			this.chartData = [
				{
					platform: '电脑端',
					num: val.pcTotal || 0,
				},
				{
					platform: '手机端',
					num: val.mobileTotal || 0,
				},
				{
					platform: '邮件',
					num: val.emailTotal || 0,
				},
			];
		},
		// 查看更多
		viewMore(path) {
			if (!this.$route.query.id) {
				this.$message({
					message: '无法查看',
					type: 'warning',
				});
			}
			let query = {
				id: this.$route.query.id,
				name: this.reportDetail.customerName,
			};

			if (path == 'enquiryList') {
				query = {};
			}

			this.$router.push({
				name: path,
				query,
			});
		},
	},
	components: { dateSwitchSelector, clientModule, googleorsocial },
};
</script>

<style lang="scss" scoped>
.report-detail {
  .message-show {
    background-color: #fff;
    padding: 30px 40px;
    font-size: 16px;
    color: #333;

    .customer-info {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 40px;

      .info-item {
        flex: 1;
        // 单行溢出
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .iconfont {
        margin-right: 2%;
        color: #999;
      }
    }

    .data-show {
      font-size: 18px;
      color: #333;

      .data-time {
        font-size: 22px;
        color: #333;
        line-height: 30px;
        margin-bottom: 20px;
      }

      .data-info {
        line-height: 25px;

        .info {
          font-size: 36px;
          color: #3da1ff;
          // font-weight: bold;
        }
      }
    }
  }

  .statistics {
    margin-top: 10px;

    .inquiry-detail {
      background-color: #fff;
    }

    .website-data {
      background-color: #fff;
    }

    .mg-left {
      margin-left: 10px;
    }

    .mg-right {
      margin-right: 10px;
    }
  }
}

.hint {
  font-size: 12px;
  line-height: 1.5em;
  color: #333;

  .title {
    font-size: 16px;
    font-weight: bold;
  }

  div {
    margin: 5px 0;
  }

  span {
    font-weight: bold;
  }
}
</style>
